module.exports = __webpack_public_path__ + "media/images/flags/64/Aruba-4c70e23c61b562ba6502671775ed8e2b.png";